import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { navLinks } from '../data/mock';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_cheat-alerts/artifacts/gnd74fuw_Copy%20of%20CheaterBeaters%20%28Stickers%20%28Circle%29%29.jpg";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3">
            <img 
              src={LOGO_URL} 
              alt="Cheater Beaters" 
              className="h-20 w-20 object-contain"
            />
            <span className="text-xl font-bold text-red-600 hidden sm:block">CHEATER BEATERS</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.href}
                className={`text-sm font-semibold uppercase tracking-wide transition-colors duration-200 ${
                  location.pathname === link.href
                    ? 'text-red-600'
                    : 'text-gray-700 hover:text-red-600'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/submit"
              className="bg-red-600 text-white px-6 py-2.5 rounded-md font-semibold text-sm uppercase tracking-wide hover:bg-red-700 transition-colors duration-200 shadow-md hover:shadow-lg"
            >
              Share Your Story
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden p-2 rounded-md text-gray-700 hover:text-red-600 hover:bg-gray-100 transition-colors"
          >
            {isOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 shadow-lg">
          <div className="px-4 py-4 space-y-2">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.href}
                onClick={() => setIsOpen(false)}
                className={`block px-4 py-3 rounded-md text-sm font-semibold uppercase tracking-wide transition-colors ${
                  location.pathname === link.href
                    ? 'bg-red-50 text-red-600'
                    : 'text-gray-700 hover:bg-gray-50 hover:text-red-600'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/submit"
              onClick={() => setIsOpen(false)}
              className="block bg-red-600 text-white text-center px-4 py-3 rounded-md font-semibold text-sm uppercase tracking-wide mt-4"
            >
              Share Your Story
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
